export default __webpack_public_path__ + "static/hero_academy-e0fdf6a4588b9a7d3f947eee59ee5785.jpg";